import { render } from "./RadioGroup.vue?vue&type=template&id=0a46083e&scoped=true"
import script from "./RadioGroup.vue?vue&type=script&lang=js"
export * from "./RadioGroup.vue?vue&type=script&lang=js"

import "./RadioGroup.vue?vue&type=style&index=0&id=0a46083e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a46083e"]])

export default __exports__